import React, { Fragment } from 'react';
import styles from './styles.module.css';
import { setState, shop } from '@/commonTypes';
import ViewportWrapper from '@/components/structure/ViewportWrapper';
import InfiniteContent from '@/components/general/InfiniteContent';
import Api from '@/api';
import ProductCard from '@/components/pages/product/ProductsContent/ProductCard';
import ServiceCard from '@/components/pages/service/SingleServiceContent/ServiceCard';
import ShopProductsInfo from './ShopProductsInfo';
import ShopServiceInfo from './ShopServiceInfo';
import Comments from '@/components/pages/blog/SingleBlogContent/Comments';
import ShopAboutSection from './ShopAboutSection';

export default function ShopMenuContent({
  activeMenu,
  list,
  setList,
  params,
  page,
  pageNumber,
  setPageNumber,
  limit,
  shop,
}: {
  activeMenu?: string | number;
  page?: string | number | null;
  params: any;
  initialList?: any;
  list?: any;
  setList: setState<any>;
  limit: number;
  apiCall?: any;
  pageNumber: string | number;
  setPageNumber: setState<string | number>;
  shop?: shop;
}) {
  return (
    <div>
      {activeMenu == 'product' && (
        <div className={`card ${styles.card}`}>
          <ShopProductsInfo
            products={list}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            shop={shop}
          />
        </div>
      )}
      {activeMenu == 'service' && (
        <div className={`card ${styles.card}`}>
          <ShopServiceInfo shop={shop} count={list?.response_details?.count} />
        </div>
      )}
      {(activeMenu == 'product' || activeMenu == 'service') && (
        <div className={` ${styles.section}`}>
          <InfiniteContent
            page={page}
            params={params}
            initialList={list}
            list={list}
            setList={setList}
            limit={limit}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            apiCall={activeMenu == 'product' ? Api.productList : Api.shopServicesLists}
            wrapperClass="w-full"
            gridClass={`w-full ${activeMenu == 'product' ? styles.grid3 : styles.grid1}`}
            clearButton={true}
            renderItem={(item, index) => (
              <Fragment key={index}>
                {activeMenu == 'product' && (
                  <ProductCard item={item} index={index} direction="vertical" />
                )}
                {activeMenu == 'service' && (
                  <ServiceCard item={item} index={index} direction="horizontal" />
                )}
              </Fragment>
            )}
            urlQuery={true}
          ></InfiniteContent>
        </div>
      )}
      {activeMenu == 'about' && <ShopAboutSection shop={shop} />}
      {activeMenu == 'comment' && (
        <Comments target="center" targetId={shop?.id} showAllRates={false} showRateTitle={true} />
      )}
    </div>
  );
}
